import styled from "styled-components"

const ListContainer = styled.div`
  background-color: white;
`

const StyledAdresseItem = styled.div`
  background-color: ${(props) =>
    props.active === true && props.clickable === true
      ? props.theme.b_color_gradients.b_dark
      : props.clickable === true
      ? "white"
      : props.theme.a_color_gradients.a_light};
  color: ${(props) =>
    props.active === true && props.clickable === true
      ? props.theme.a_color_gradients.a_medium
      : "black"};
  & a {
    color: ${(props) =>
      props.active === true && props.clickable === true
        ? props.theme.a_color_gradients.a_medium
        : "black"};
  }
`

export { ListContainer, StyledAdresseItem }
